import { Component } from '@theme/component';

/**
 * Keeps one row of a kp-accordion open at a time.
 *
 * The native way to do this is a shared `name` on each <details>, but the rows
 * are separate theme blocks and cannot read the parent's id, so the grouping
 * happens here instead. Without JavaScript every row still opens and closes on
 * its own, which is the same content, just less tidy.
 */
class KpAccordion extends Component {
  connectedCallback() {
    super.connectedCallback();

    if (this.dataset.singleOpen !== 'true') return;

    // 'toggle' does not bubble, so listen during the capture phase.
    this.addEventListener('toggle', this.#handleToggle, true);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('toggle', this.#handleToggle, true);
  }

  /** @param {Event} event */
  #handleToggle = (event) => {
    const row = event.target;
    if (!(row instanceof HTMLDetailsElement) || !row.open) return;

    for (const other of this.querySelectorAll('details[open]')) {
      if (other !== row) other.open = false;
    }
  };
}

if (!customElements.get('kp-accordion')) {
  customElements.define('kp-accordion', KpAccordion);
}
